import * as React from 'react';

import { PropertySimilar } from '@shared-ui/lodging-property-details';

import { UitkSpacing } from 'uitk-react-spacing';

import { PropertySearchCriteriaInput, ShoppingContextInput } from 'src/common/__generated__/api';
import { SimpleLazyLoadWrapper } from 'src/common/components/common/lazy/simple-lazy-load-wrapper';

export interface SimilarPropertiesWrapperProps {
  inputs?: {
    propertyId?: string;
    shoppingContext?: ShoppingContextInput;
    searchCriteria?: PropertySearchCriteriaInput;
  };
}

const SimilarPropertiesWrapper: React.FC<SimilarPropertiesWrapperProps> = ({ inputs }) => {
  if (inputs && !inputs.shoppingContext?.multiItem) {
    return (
      <UitkSpacing margin={{ block: 'three', small: { inline: 'six' }, medium: { inline: 'unset' } }}>
        <div data-stid="SimilarProperties">
          <SimpleLazyLoadWrapper>
            <PropertySimilar inputs={inputs} skipSsr={true} scrollTo="Offers" />
          </SimpleLazyLoadWrapper>
        </div>
      </UitkSpacing>
    );
  }

  return null;
};

export const SharedUiSimilarPropertiesWrapper = SimilarPropertiesWrapper;
SharedUiSimilarPropertiesWrapper.displayName = 'SharedUiSimilarPropertiesWrapper';
